import { render, staticRenderFns } from "./UploadImageForm.vue?vue&type=template&id=5f879f5e&scoped=true&"
import script from "./UploadImageForm.vue?vue&type=script&lang=ts&"
export * from "./UploadImageForm.vue?vue&type=script&lang=ts&"
import style0 from "./UploadImageForm.vue?vue&type=style&index=0&id=5f879f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f879f5e",
  null
  
)

export default component.exports